// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    supplierList: [],
    totalRows: 0,
    rowsPerPage: 5,
    page: 0,
    selectedSupplier: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'supplier',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setSuppliers(state, action) {
            state.supplierList = action.payload;
        },
        setSupplierRowPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setSupplierPage(state, action) {
            state.page = action.payload;
        },
        setTotalRows(state, action) {
            state.totalRows = action.payload;
        },
        setSelectedSupplier(state, action) {
            state.selectedSupplier = action.payload;
        },
        setSupplier(state, action) {
            const data = action.payload;
            const rowIndex = state.supplierList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.supplierList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedSupplier, setSupplierRowPerPage, setSupplierPage } = slice.actions;
// ----------------------------------------------------------------------

export function getSuppliers(data) {
    return async () => {
        try {
            const response = await axios.post('/supplier/list', data);
            if (response.data.status) {
                dispatch(slice.actions.setSuppliers(response.data.data));
                dispatch(slice.actions.setTotalRows(response.data.total_rows));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getSupplier(id) {
    return async () => {
        try {
            const response = await axios.post('/supplier/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setSupplier(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function saveSupplier(data) {
    return async function () {
        const response = await axios.post('supplier/save', data);
        return response;
    };
}

export function updateSupplier(data) {
    return async function () {
        const response = await axios.post('supplier/update', data);
        return response;
    };
}

export function deleteSupplier(data) {
    return async function () {
        const response = await axios.post('supplier/delete', data);
        return response;
    };
}
